import { render, staticRenderFns } from "./noticeList1.vue?vue&type=template&id=474e4b0c&scoped=true"
import script from "./noticeList1.vue?vue&type=script&lang=js"
export * from "./noticeList1.vue?vue&type=script&lang=js"
import style0 from "./noticeList1.vue?vue&type=style&index=0&id=474e4b0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474e4b0c",
  null
  
)

export default component.exports